import { DiContainer } from '@jack-henry/frontend-utils/di';
import { DynamicComponentExitReason } from '@jack-henry/frontend-utils/lit/dynamic-component-registry';
import { OpenIdleDialogFn } from '@treasury/domain/services/logout/idle-signout-service';
import { TmDialogService } from '@treasury/presentation/services/dialog';
import type { OmegaDialogService } from '../../services/omega-dialog';

const continueLabel = 'Continue Working';
const logoutLabel = 'Log Out';
const prompt = `For your protection, you will be logged out automatically due to inactivity. If
you would like to remain logged in, please click '${continueLabel}' below to
keep your session active.`;

export const openIdleDialog: OpenIdleDialogFn = async function openIdleDialog(config) {
    const di = await DiContainer.getInstance();
    const dialogService = di.get(TmDialogService) as OmegaDialogService;
    const { logoSource } = config;
    const result = dialogService.open(
        prompt,
        'Session Timeout',
        {
            buttons: [
                {
                    reason: DynamicComponentExitReason.Confirm,
                    label: logoutLabel,
                },
                {
                    reason: DynamicComponentExitReason.Cancel,
                    label: continueLabel,
                },
            ],
        },
        {
            logoSource,
        }
    );

    return {
        getDetail: async () => {
            const { reason } = await result;
            return reason === DynamicComponentExitReason.Confirm ? 'logout' : 'continue';
        },
        close: () => dialogService.close(DynamicComponentExitReason.ForceClose),
    };
};
